import {Component, OnInit, Inject, ViewChild, ElementRef, Renderer2} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {FormControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {TaskService} from './task.service';
import {ToastrService} from 'ngx-toastr';
import {ProventumApiService} from '@app/services/proventum-api.service';
import {NgbDatepicker, NgbDateStruct, NgbDateParserFormatter, NgbInputDatepicker} from '@ng-bootstrap/ng-bootstrap';
import {DialogEstimateComponent} from '@common-components/dialog-estimate/dialog-estimate.component';
import {AngularEditorConfig} from '@kolkov/angular-editor';
import {Globals} from '@app/services/globals.service';
import {ConstantsService} from '@app/services/constants/constants.service';
import {History} from '@app/interfaces/history';
import {BridgeService} from '@app/services/bridge/bridge.service';
import {NgbDateCustomParserFormatter} from '@app/date-format/dateformat';
import {environment} from "@env/environment";
import {Task} from "@app/interfaces/task";
import {BackendResponse} from "@app/interfaces/backendResponse";
import {ProjectsService} from "@components/projects/projects.service";
import {NgModel} from "@angular/forms";
import {OdmoriService} from '@app/components/odmori/odmori.service';
import {DatePipe} from '@angular/common';

export interface DateInt {
    year: number,
    month: number,
    day: number
}

export interface TimeInt {
    hour: number,
    minute: number,
}

const now = new Date();

const equals = (one: NgbDateStruct, two: NgbDateStruct) =>
    one && two && two.year === one.year && two.month === one.month && two.day === one.day;

const before = (one: NgbDateStruct, two: NgbDateStruct) =>
    !one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
        ? false : one.day < two.day : one.month < two.month : one.year < two.year;

const after = (one: NgbDateStruct, two: NgbDateStruct) =>
    !one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
        ? false : one.day > two.day : one.month > two.month : one.year > two.year;


@Component({
    selector: 'app-new-task-modal',
    templateUrl: './new-task-modal.component.html',
    styleUrls: ['./new-task-modal.component.css'],
    providers: [
        {provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter}
    ]
})

export class NewTaskModalComponent implements OnInit {

    constructor(public dialogRef: MatDialogRef<NewTaskModalComponent>,
                public taskService: TaskService,
                private formBuilder: FormBuilder,
                private toastr: ToastrService,
                public dialog: MatDialog,
                public bridge: BridgeService,
                public proventumApiService: ProventumApiService,
                public matDialog: MatDialog,
                @Inject(MAT_DIALOG_DATA) public dialogData: { 
                    mode: string, 
                    task: any, 
                    data?: any, 
                    sort?: string, 
                    sprintId?: string, 
                    project?: any, 
                    backlog?: boolean,
                    module?: string },
                public globals: Globals,
                private constants: ConstantsService,
                private projectsService: ProjectsService,
                private _parserFormatter: NgbDateParserFormatter,
                private renderer: Renderer2,
                private odmoriService: OdmoriService,
                private datePipe: DatePipe) {
                    
                this.generateYears(1900, new Date().getFullYear()); 
    }

    generateYears(startYear: number, endYear: number) {
        for (let year = endYear; year >= startYear; year--) {
          this.years.push(year);
        };
    };
    
    onYearChange(event: Event) {
        this.selectedYear = +(event.target as HTMLSelectElement).value;
    };

    form: FormGroup;

    title = new FormControl('', [Validators.required, Validators.minLength(1), this.noWhitespaceValidator]);
    assigned = new FormControl([], Validators.required);
    validator = new FormControl([], Validators.required);
    deadlineDate = new FormControl('', Validators.required);
    deadlineTime = new FormControl({hour: 16, minute: 0}, Validators.required);
    absenceTime = new FormControl({hour: 8, minute: 0}, Validators.required);

    meetingDate = new FormControl('', Validators.required);
    meetingStartTime = new FormControl({hour: 12, minute: 0}, Validators.required);
    meetingEndTime = new FormControl({hour: 12, minute: 30}, Validators.required);

    reminderDate = new FormControl('', Validators.required);
    reminderStartTime = new FormControl({hour: 12, minute: 0}, Validators.required);

    executionDate = new FormControl('');
    executionStartTime = new FormControl('');

    taskProject = new FormControl('', Validators.required);

    replacement_colleague = new FormControl([]);

    description = '';
    attachments = [];
    estimation = '';
    taskType: { name: string, _id: string } = null;
    project: { name: string, _id: string } = null;
    project_id = null;
    tags = [];
    _id: string;
    parentTaskId: string; // taskId ciji subtask kreiramo

    today = new Date();
    eventType = 'task';
    selectedTaskTypeLabel = 'Napravi zadatak';
    estimationButtonTitle = 'Procjena vremena';
    priority: string = 'low';
    priorities = [{id: 'low', name: 'Nisko'}, {id: 'medium', name: 'Srednje'}, {id: 'high', name: 'Visoko'}];
    generatedTaskNumber: string;
    loader = false;

    time = {hour: 12, minute: 0};
    time2 = {hour: 12, minute: 30};
    time3 = {hour: 12, minute: 0};

    dateFromCalendar = {start: '', end: ''};
    cliUrl = environment.cliURL;

    adminRole = false;
    buttonDisabled = false;
    backlogTask: boolean = false;

    maxDate: NgbDateStruct;
    minDate: NgbDateStruct;
    
    fromDateDeadline: any;
    toDateDeadline: any;
    absencePeriod: any;
    showErrorBorder: boolean = false;
  
    startCreationDateExecution: NgbDateStruct;
    hoveredDateCreationDate: NgbDateStruct;
    @ViewChild("creation_date_range") creationInput: NgbInputDatepicker;
    @ViewChild(NgModel) dateCreationPick: NgModel;
    @ViewChild('creationDateRangeInput') creationDateRangeInput: ElementRef;

    fromCreationDateDeadline: any;
    toCreationDateDeadline: any;
    modelCreationDate: any;

    years: number[] = [];
    selectedYear: number;

    isHoveredCreationDate = date => this.fromCreationDateDeadline && !this.toCreationDateDeadline && this.hoveredDateCreationDate && after(date, this.fromCreationDateDeadline) && before(date, this.hoveredDateCreationDate);
    isInsideCreationDate = date => after(date, this.fromCreationDateDeadline) && before(date, this.toCreationDateDeadline);
    isFromCreationDate = date => equals(date, this.fromCreationDateDeadline);
    isToCreationDate = date => equals(date, this.toCreationDateDeadline);

    buttonDisabledHoliday: boolean = false;
    deadlineObj: any;

    borderError: boolean = false;

    buttons = [
        {
            name: 'Zadatak',
            type: 'task'
        },
        {
            name: 'Sastanak',
            type: 'meeting'
        },
        {
            name: 'Bilješka',
            type: 'note'
        },
        {
            name: 'Podsjetnik',
            type: 'reminder'
        }
    ];

    mode = 'new';
    sort = 'task';
    module = null;

    projectDisabled = false;
    creatorId: number;

    formSubmitted = false;
    sprintId = null;
    projects = [];
    types = [];

    user: any;

    config: AngularEditorConfig = {
        editable: true,
        spellcheck: true,
        height: '17rem',
        minHeight: '17rem',
        placeholder: 'Enter text here...',
        translate: 'no',
        defaultParagraphSeparator: 'p',
        defaultFontName: 'Arial',
        customClasses: [
            {
                name: 'quote',
                class: 'quote'
            },
            {
                name: 'redText',
                class: 'redText'
            },
            {
                name: 'titleText',
                class: 'titleText',
                tag: 'h1'
            }
        ],
        toolbarHiddenButtons: [
            [
                'insertUnorderedList',
                'insertOrderedList',
                'heading',
                'fontName'
            ],
            [
                'fontSize',
                'textColor',
                'backgroundColor',
                'customClasses',
                'link',
                'unlink',
                'insertImage',
                'insertVideo',
                'insertHorizontalRule',
                'removeFormat',
                'toggleEditorMode'
            ]]
    };


    async ngOnInit() {

        this.loader = true;
        this.form = this.formBuilder.group({
            title: this.title,
            assigned: this.assigned,
            validators: this.validator,
            deadlineDate: this.deadlineDate,
            deadlineTime: this.deadlineTime,
            absenceTime: this.absenceTime,
            taskProject: this.taskProject,
            replacement_colleague: this.replacement_colleague
        });

        this.creatorId = this.constants.getLoggedInUserId();

        if (!this.dialogData) {

            this.getFromChildType(this.eventType);
            this.loader = false;
        } else {
            this.mode = this.dialogData.mode;
            this.sort = this.dialogData.sort;
            
            if(this.dialogData.module) {
                this.module = this.dialogData.module;
                this.selectedTaskTypeLabel = 'Novi zahtjev za slobodan dan/godišnji odmor';
            };
        }

        this.dialogRef.keydownEvents().subscribe(event => {
            if (event.key === "Escape") {
                this.dialogRef.close();
            }
        });


        await this.arrangeTaskData();
        await this.getProjects();
        this.loader = false;
        const checkIsAdmin: any[] = this.constants.getAdmins();
        const adm = checkIsAdmin.indexOf(parseInt(this.constants.creator_id, 10));
        if (adm > -1) {
            this.adminRole = true;
        }

        this.maxDate = {year: now.getFullYear() + 1, month: now.getMonth() + 1, day: now.getDate()};
        this.minDate = {year: now.getFullYear() - 24, month: now.getMonth() + 1, day: now.getDate()};
        this.fromCreationDateDeadline = {year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate()};
    }

    arrangeTaskData() {
        return new Promise(async (resolve, reject) => {
            try {
                const task: Task = this.dialogData.task;
                if (this.mode === 'new') {
                    await this.generateTaskNumber();
                    let id= +this.constants.creator_id;
                    this.validator.setValue([id]);
                    this.assigned.setValue([id]);

                    //provjeravamo da li je poslednji dan u mjesecu
                    let lastDay = new Date(this.today.getFullYear(), this.today.getMonth() + 1, 0);
                    let last_day = lastDay.getDate();
                    let inTwoDays = this.today.getDate() + 2;
                    let deadline = inTwoDays > last_day ?
                        {
                            year: (this.today.getFullYear()),
                            month: (this.today.getMonth() + 2),
                            day: (1)
                        } : {
                            year: (this.today.getFullYear()),
                            month: (this.today.getMonth() + 1),
                            day: (this.today.getDate())
                        };
                    this.deadlineDate.setValue(deadline);
                    this.backlogTask = this.dialogData.backlog == true;

                    if (this.dialogData.sprintId || this.backlogTask === true) {
                        this.sprintId = this.dialogData.sprintId;
                        this.projectDisabled = true;
                        this.project = this.dialogData.project;
                        this.project_id = this.dialogData.project._id;
                        this.taskProject.setValue(this.dialogData.project);
                    }


                } else if (this.mode === 'edit') {


                    this.getFromChildType(task.type);

                    // common data
                    this._id = task._id;
                    this.generatedTaskNumber = task.identifier;
                    this.title.setValue(task.title);
                    this.assigned.setValue(task.assigned);
                    this.description = task.description;
                    this.project = task.project;
                    this.project_id = task.project_id;
                    this.taskProject.setValue(task.project);
                    this.projectDisabled = task.sort === 'subtask';

                    if (task.type === 'task') {
                        this.validator.setValue(task.validator_id);
                        this.deadlineDate.setValue(this.onNavigate(task.deadline.split(" ")[0]));
                        this.deadlineTime.setValue(this.getTimeString(task.deadline.split(" ")[1]));


                        if (task.execution) {
                            this.executionDate.setValue(this.onNavigate(task.execution.split(" ")[0]));
                            this.executionStartTime.setValue(this.getTimeString(task.execution.split(" ")[1]));
                        } else {
                            this.executionStartTime.setValue(null);
                        }
                        this.taskType = task.task_type;
                        this.estimation = task.estimateTime;
                        this.estimationButtonTitle = task.estimateTime ? task.estimateTime : 'Procjena vremena';
                    } else if (task.type === 'meeting') {
                        this.meetingDate.setValue(this.onNavigate(task.meeting_time['start'].split(" ")[0]));
                        this.meetingStartTime.setValue(this.getTimeString(task.meeting_time['start'].split(" ")[1]));
                        this.meetingEndTime.setValue(this.getTimeString(task.meeting_time['end'].split(" ")[1]));
                    } else if (task.type === 'reminder') {
                        this.reminderDate.setValue(this.onNavigate(task.reminder_time['start'].split(" ")[0]));
                        this.reminderStartTime.setValue(this.getTimeString(task.reminder_time['start'].split(" ")[1]));
                    }


                    this.tags = task.tags;
                    this.priority = task.priority;
                    this.attachments = task.attachments;
                } else if (this.dialogData.mode == 'copy') {
                    this.projectDisabled = true;
                    this.parentTaskId = task._id;
                    this.project = task.project;
                    this.project_id = task.project_id;
                    this.taskProject.setValue(task.project_id);
                    this.tags = task.tags;
                    this.validator.setValue([parseInt(this.constants.creator_id)]);
                    this.assigned.setValue([]);
                    this.generateTaskNumber();
                    this.backlogTask = this.dialogData.backlog == true;

                    if (task.type === 'task') {
                        this.deadlineDate.setValue(this.onNavigate(task.deadline.split(" ")[0]));
                        this.deadlineTime.setValue(this.getTimeString(task.deadline.split(" ")[1]));
                    }
                } else if (this.mode == 'calendarDatesSelected') {
                    this.dateFromCalendar.start = this.dialogData.data.startStr;
                    this.dateFromCalendar.end = this.dialogData.data.endStr;
                    this.deadlineDate.setValue(this.onNavigate(this.dateFromCalendar.end.replace("-/g", "/")));
                    this.meetingDate.setValue(this.onNavigate(this.dateFromCalendar.start.replace("-/g", "/")));
                    this.reminderDate.setValue(this.onNavigate(this.dateFromCalendar.start.replace("-/g", "/")));
                    if (this.dialogData.data.startStr !== this.dialogData.data.endStr) {
                        this.executionDate.setValue(this.onNavigate(this.dateFromCalendar.start.replace("-/g", "/")));
                        this.time3 = {hour: 12, minute: 0};
                    }


                    this.assigned.setValue([parseInt(this.constants.creator_id, 10)]);
                    this.validator.setValue([parseInt(this.constants.creator_id, 10)]);

                    this.deadlineDate.setValue(this.onNavigate(this.dateFromCalendar.end.replace("-/g", "/")));
                    this.meetingDate.setValue(this.onNavigate(this.dateFromCalendar.start.replace("-/g", "/")));
                    this.reminderDate.setValue(this.onNavigate(this.dateFromCalendar.start.replace("-/g", "/")));

                    if (this.dialogData.data.view.type === 'timeGridWeek') {
                        const start: Date = new Date(this.dateFromCalendar.start);
                        this.executionDate.setValue({
                            year: +(start.getFullYear().toString()),
                            month: +((start.getMonth() + 1).toString()),
                            day: +(start.getDate().toString())
                        });

                        let startTime: Date = this.dialogData.data.start;
                        let endTime: Date = this.dialogData.data.end;

                        const time = {
                            hour: startTime.getHours(),
                            minute: startTime.getMinutes()
                        };

                        const _time = {
                            hour: endTime.getHours(),
                            minute: endTime.getMinutes()
                        };

                        this.deadlineTime.setValue(_time);
                        this.meetingStartTime.setValue(time);
                        this.meetingEndTime.setValue(_time);
                        this.reminderStartTime.setValue(time);
                        this.executionStartTime.setValue(time);
                        this.time3 = time;
                        this.executionDate.setValue(this.onNavigate(this.dateFromCalendar.start.replace("-/g", "/")));
                    }

                }

                resolve(true);
            } catch (e) {
                reject(e);
            }
        });
    }


    openEstimaionTimeDialog() {
        const dialogRef = this.dialog.open(DialogEstimateComponent,
            {height: '28%'});
        dialogRef.afterClosed().subscribe(result => {
            if (result !== 'false') {
                const message = result.days == 1 ? ' dan ' : ' dana ';
                const x = result.days + message + result.hours + 'h ' + result.min + 'm';
                this.estimation = x;
                this.estimationButtonTitle = x;
            } else {
                this.estimation = null;
                this.estimationButtonTitle = 'Procjena vremena';
            }
        });
    }


// space ne moze biti prvi i jedini karakter u naslovu - ovo je funkcija za to
    noWhitespaceValidator(control: FormControl) {
        const isWhitespace = (control && control.value && control.value.toString() || '').trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : {'whitespace': true};
    }


    resetEstimate() {
        this.estimation = '';
        this.estimationButtonTitle = 'Procjena vremena';
    }

    onNavigate(dateStr: string) {

        if (dateStr.includes('T')) {
            dateStr = dateStr.split('T')[0];
        }
        let str = dateStr.split('-');
        let y = str[0];
        let m = str[1];
        let d = str[2];

        const dateObj = {year: +y, month: +m, day: +d};
        return dateObj;
    }

    changeTextareaSize() {
        $("textarea").each(function () {
            this.setAttribute("style", "height:" + (this.scrollHeight) + "px;overflow-y:hidden;");
        }).on("input", function () {
            this.style.height = "auto";
            this.style.height = (this.scrollHeight) + "px";
        });
    }

    //vrsta zadatka
    getTaskType(data: { name: '', _id: '' }) {
        this.taskType = this.eventType === 'task' ? data : null;
    }

    getTaskTags(event) {
        this.tags = event;
    }


    getFromChildType(type: any) {
        this.eventType = type;
        if (type === 'task') {
            this.selectedTaskTypeLabel = 'Napravi zadatak';
            this.form = this.formBuilder.group({
                title: this.title,
                assigned: this.assigned,
                validators: this.validator,
                deadlineDate: this.deadlineDate,
                deadlineTime: this.deadlineTime,
                taskProject: this.taskProject

            });
        } else if (type === 'note') {
            this.selectedTaskTypeLabel = 'Napravi bilješku';
            this.form = this.formBuilder.group({
                title: this.title,
            });

        } else if (type === 'reminder') {
            this.selectedTaskTypeLabel = 'Napravi podsjetnik';
            //// todo ovdje se vratiti i vidjeti sta je ovo !!!!!!!!!!!!!!!!!!
            if (this.dateFromCalendar.start !== '') {
                this.onNavigate(this.dateFromCalendar.start);
            }

            this.form = this.formBuilder.group({
                title: this.title,
                reminderDate: this.reminderDate,
                reminderStartTime: this.reminderStartTime
            });
        } else if (type === 'meeting') {
            this.selectedTaskTypeLabel = 'Napravi sastanak';
            if (this.dateFromCalendar.start !== '') {
                this.onNavigate(this.dateFromCalendar.start);
            }


            this.form = this.formBuilder.group({
                title: this.title,
                meetingDate: this.meetingDate,
                meetingStartTime: this.meetingStartTime,
                meetingEndTime: this.meetingEndTime,
                assigned: this.assigned
            });
        }
    }

    generateTaskNumber() {
        if (this.dialogData.mode === 'new' && this.sort === 'task') {
            this.taskService.generateTaskNumber(this.sort).subscribe(result => {
                if (result.type === 'success') {
                    this.generatedTaskNumber = result.data;
                }
            });
        } else {
            this.taskService.generateTaskNumber(this.sort, this.dialogData.task._id, this.dialogData.task.identifier).subscribe(result => {
                if (result.type === 'success') {
                    this.generatedTaskNumber = result.data;
                }
            });
        }
    }


    public findInvalidControls() {
        const invalid = [];
        const controls = this.form.controls;
        for (const name in controls) {
            if (controls[name].invalid) {
                invalid.push(name);
            }
        }
    }

    async saveTask() {
        this.formSubmitted = true;
        this.markAllAsTouched();
        if (this.form.invalid) {
            this.toastr.info('Molimo Vas popunite ispravno formu.');
            return;
        } else {
            this.buttonDisabled = true;

            if (this.eventType === 'meeting') {
                const compareHours = await this.compareMeetingTime();
                if (compareHours) {
                    this.toastr.info('Vrijeme početka sastanka mora biti manje od završetka sastanka.');
                    this.buttonDisabled = false;
                    return;
                }
            }
        }
        this.findInvalidControls();
        if (this.eventType === 'meeting') {
            const compareHours = await this.compareMeetingTime();
            if (compareHours) {
                this.toastr.info('Vrijeme početka sastanka mora biti manje od završetka sastanka.');
                return;
            }
        }
        const meetingDateTime = {
            start: this.createDateStringFromObjects(this.meetingDate.value, this.meetingStartTime.value),
            end: this.createDateStringFromObjects(this.meetingDate.value, this.meetingEndTime.value)
        };

        const deadlineDateTime = this.createDateStringFromObjects(this.deadlineDate.value, this.deadlineTime.value);

        const executionDateTime = this.createDateStringFromObjects(this.executionDate.value, this.time3);

        const reminderDateTime = this.createDateStringFromObjects(this.reminderDate.value, this.reminderStartTime.value);

        const data = {
            _id: this._id,
            title: this.title.value,
            description: this.description,
            assigned: this.eventType === 'task' || this.eventType === 'meeting' ? this.assigned.value : null,
            validator_id: this.eventType === 'task' ? this.validator.value : null,
            project_id: this.eventType === 'task' ? this.project_id : null,
            estimateTime: this.eventType === 'task' && this.estimation ? this.estimation : null,
            meeting_time: this.eventType === 'meeting' ? meetingDateTime : null,
            reminder_time: this.eventType === 'reminder' ? reminderDateTime : null,
            type: this.eventType,
            tags: this.tags,
            deadline: this.eventType === 'task' ? deadlineDateTime : null,
            attachments: this.attachments,
            execution: (this.executionDate.valid && this.executionStartTime.valid && this.eventType === 'task') ? executionDateTime : null,
            sort: this.sort,
            task_id: this.parentTaskId,
            mode: this.mode,
            task_type: this.taskType ? this.taskType._id : null,
            backlog: this.backlogTask,
            sprintId: this.dialogData.sprintId ? this.dialogData.sprintId : null,
            priority: this.priority
        };

        this.taskService.saveTask(data).subscribe(async (response: BackendResponse) => {
            if (response.type === 'success') {
                this.toastr.success('Uspješno ste dodali zadatak.');
                this.buttonDisabled = false;
                let user = this.constants.userData;

                this.taskService.taskCreated.next(this.eventType);
                const task: Task = response.data;
                if (this.dialogData.mode === 'edit') {
                    let data: History = {
                        'task_id': this._id,
                        'type': 'task',
                        'action': 'update',
                        'user_id': parseInt(this.constants.creator_id),
                        'sort': this.sort,
                        'message': `Korisnik ${user['first_name']} ${user['last_name']} je izmijenio task.`,
                        'data': null,
                        'task_identifier': task.identifier
                    };
                    this.taskService.taskChange(data).subscribe((response: BackendResponse) => {
                        if (response.type !== 'success') {
                            this.toastr.error('Došlo je do greške prilikom čuvanja istorije taska.');
                        }
                    });
                } else {
                    // Kreiram notifikaciju na Proventum
                    this.sendNotificationToProventum(task);
                }
                this.dialogRef.close(true);
                this.globals.getAllTagsForUser();
            } else if (response.type === 'info') {
                this.toastr.info('Rok za izvršenje podzadatka mora biti manji ili isti kao kod zadatka.');
                this.buttonDisabled = false;
                return;

            } else {
                this.toastr.error('Došlo je do greške, molimo Vas obratite se korisničkoj podršci.');
            }
        });


    }

    closeModal() {
        this.dialogRef.close(false);
    }

    getTaskDescription(data) {
        this.description = data;
    }

    getTaskProject(event) {
        this.project = event;
        this.taskProject.setValue(event);
        this.project_id = event != null ? event['_id'] : null;
    }

    async compareMeetingTime() {
        return this.meetingStartTime.value.hour > this.meetingEndTime.value.hour;
    }

    sendNotificationToProventum(task: Task) {

        const user = this.constants.userData;

        //validacija da se ne salje samom sebi notif
        const notificationArray = this.assigned.value.filter(item => item !== this.creatorId);

        const link = this.cliUrl + '/view-task/' + task['_id'];
        let notif = {
            notification: {
                title: 'Dobili ste novi zadatak',
                description: `Korisnik ${user['first_name']} ${user['last_name']} Vam je izdao zadatak - ` + this.title.value,
                employers: notificationArray,
                type: 'zadatak',
                link: link
            }
        };

        if (notificationArray.length > 0) {
            this.bridge.sendDataViaBridge(notif);
        }

    }

    onTitlePaste(event) {
        let clipboardData = event.clipboardData;
        let pastedText = clipboardData.getData('text');
        let title: string = this.title.value + pastedText;
        this.title.setValue(title.trim());
        event.preventDefault();
    }

    setPriority(event) {
        this.priority = event.value;
    }

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    getAssignedIds(data: number[]) {
        this.form.patchValue({'assigned': data});
    }

    getValidatorIds(data: number[]) {
        this.form.patchValue({'validators': data});
    }

    getReplacementIds(data: number[]) {
        this.form.patchValue({'replacement_colleague': data});
    }

    getAttachmentLinks(files: []) {
        this.attachments = files;
    }

    createDateStringFromObjects(dateObj: { year: number, month: number, day: number }, timeObj: { hour: number, minute: number }) {
        if (!dateObj || !timeObj) return null;
        // add leading zeros
        let hour = timeObj.hour < 10 ? '0' + timeObj.hour.toString() : timeObj.hour.toString();
        let minute = timeObj.minute < 10 ? '0' + timeObj.minute.toString() : timeObj.minute.toString();
        return dateObj.year + '-' + dateObj.month + '-' + dateObj.day +
            ' ' + hour + ':' + minute;
    }

    getTimeString(date: string) {
        let dateStr: TimeInt = {hour: 0, minute: 0};
        dateStr.hour = +date.split(':')[0];
        dateStr.minute = +date.split(':')[1];
        return dateStr;
    }

    getProjects() {

        this.projectsService.getProjects().subscribe((response: BackendResponse) => {
            if (response.type === 'success') {
                this.projects = response.data;
            } else {
                this.toastr.error('Došlo je do greške prilikom izvlačenja podataka za projekte.');
            }
            
        });
    }

    markAllAsTouched() {
        this.form.markAllAsTouched();
    }

    onDateSelection(date: NgbDateStruct) {
        let parsed = '';
        if (!this.fromCreationDateDeadline && !this.toCreationDateDeadline) {
            this.fromCreationDateDeadline = date;
        } else if (this.fromCreationDateDeadline && !this.toCreationDateDeadline && (after(date, this.fromCreationDateDeadline) || equals(date, this.fromCreationDateDeadline))) {
            this.toCreationDateDeadline = date;
            this.creationInput.close();
        } else {
            this.toCreationDateDeadline = null;
            this.fromCreationDateDeadline = date;
        }

        if (this.fromCreationDateDeadline) {
            parsed += this._parserFormatter.format(this.fromCreationDateDeadline);
        }

        if (this.toCreationDateDeadline) {
            parsed += ' - ' + this._parserFormatter.format(this.toCreationDateDeadline);
        }

        this.renderer.setProperty(this.creationDateRangeInput.nativeElement, 'value', parsed);
        this.deadlineObj = {from: this.fromCreationDateDeadline, to: this.toCreationDateDeadline};
    };

    saveHolidayRequest() {
        this.buttonDisabledHoliday = true;

        if(!this.deadlineObj || !this.deadlineObj.from) {
            this.showErrorBorder = true;
            this.toastr.info('Molimo vas izaberite period odsustva.');
            this.buttonDisabledHoliday = false;

            return;
        };

        if(this.validator.value.length === 0) {
            this.toastr.info('Molimo vas izaberite menadžera.');
            this.buttonDisabledHoliday = false;

            return;
        };

        if(!this.deadlineObj.to) {
            this.deadlineObj.to = this.deadlineObj.from;
        };

        if(typeof this.selectedYear === 'undefined') {
            this.toastr.info('Molimo vas izaberite godinu iz koje su zahtjevani dani godišnjeg odmora.');
            this.buttonDisabledHoliday = false;
            
            this.borderError = true;

            return;
        };

        const data = {
            'manager': this.validator.value,
            'dateFrom': this.deadlineObj.from,
            'dateTo': this.deadlineObj.to,
            'absenceHours': this.absenceTime.value.hour,
            'absenceMinutes': this.absenceTime.value.minute,
            'description': this.description,
            'replacement_colleague': this.replacement_colleague.value,
            'absence_year': this.selectedYear
        };

        if(!this.deadlineObj.to) {
            this.deadlineObj.to = this.deadlineObj.from;
        };

        if(this.replacement_colleague.value.length > 1) {
            this.toastr.info('Molimo vas izaberite jednog kolegu koji će da vas mijenja tokom odsustva.');
            this.buttonDisabledHoliday = false;

            return;
        };

        if(this.validator.value.length > 1) {
            this.toastr.info('Molimo vas izaberite jednog menadžera koji će da vam validira odsustvo.');
            this.buttonDisabledHoliday = false;

            return;
        };

        this.odmoriService.saveHolidayRequest(data).subscribe(result => {
            this.buttonDisabledHoliday = false;

            if (result.type === 'success') {

                if(this.replacement_colleague.value.length > 0) {
  
                    this.user = this.globals.getAllUsers().find(value => this.creatorId === value.id);

                    const formatDateFrom = this.deadlineObj.from.year + '-' + this.deadlineObj.from.month + '-' + this.deadlineObj.from.day;
                    const formatDateTo = this.deadlineObj.to.year + '-' + this.deadlineObj.to.month + '-' + this.deadlineObj.to.day;

                    const dateFrom = new Date(formatDateFrom);
                    const dateTo = new Date(formatDateTo);

                    var description = this.user.first_name + ' ' + this.user.last_name + ' vas je izabrao/la da ga/je mijenjate u u periodu od ' + this.datePipe.transform(dateFrom, 'dd-MM-yyyy') + ' do ' + this.datePipe.transform(dateTo, 'dd-MM-yyyy') + '.';
                    var title = 'Mijenjanje kolege/koleginice u periodu od ' + this.datePipe.transform(dateFrom, 'dd-MM-yyyy') + ' do ' + this.datePipe.transform(dateTo, 'dd-MM-yyyy'); 
                    
                    var descriptionForManager = this.user.first_name + ' ' + this.user.last_name + ' je kreirao zahtjev za odmor/slobodan dan u periodu od ' + this.datePipe.transform(dateFrom, 'dd-MM-yyyy') + ' do ' + this.datePipe.transform(dateTo, 'dd-MM-yyyy') + '. Molimo vas validirajte zahtjev.';
                    var titleForManager = 'Zahtjev za odmor/slobodan dan ' + this.user.first_name + ' ' + this.user.last_name  + ' u periodu od ' +  this.datePipe.transform(dateFrom, 'dd-MM-yyyy') + ' do ' + this.datePipe.transform(dateTo, 'dd-MM-yyyy');

                    this.sendNotification(title, description, this.replacement_colleague.value, null);
                    this.sendNotification(titleForManager, descriptionForManager, this.validator.value, null);
                };

                this.toastr.success('Uspješno sačuvan zahtjev.');

                this.dialogRef.close('reload');

                return;
            };

            this.toastr.error('Došlo je do greške prilikom čuvanja zahtjeva za odmor. Molimo vas da se obratite korisničkoj podršci.');
        });
    };

    sendNotification(title, description, employee, reqId) {
        let link = null;

        if(reqId) {
            link = this.cliUrl + '/zahtjev-pregled/' + reqId;
        };
        
        const notif = {
            notification: {
                title: title,
                description: description,
                employers: employee,
                type: 'informacija',
                link: link
            }
        };
        
        this.bridge.sendDataViaBridge(notif);
    };

}
